
$(document).ready(function() {
    var $grid = $('.grid');
    $grid.imagesLoaded( function(){

         $grid.masonry({
              itemSelector: '.grid-item', // use a separate class for itemSelector, other than .col-
              columnWidth: '.grid-sizer',
              percentPosition: true,
              horizontalOrder: true
         });
    });
    $('.grid').masonry({
      itemSelector: '.grid-item', // use a separate class for itemSelector, other than .col-
      columnWidth: '.grid-sizer',
      percentPosition: true
      //initLayout: false
      //stagger: 250,
    });
   setTimeout(function() {
    
    AOS.init(); 
   }, 200);

    $(window).resize(function () {
        getMobileOperatingSystem();
    });

    function getMobileOperatingSystem() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            $(".offer-coupon").each(function (index) {
                var myid = $(this).attr('data-id');
                var myindex = $(this).attr('data-index');
                var mycta = $(this).find(".appdownload").attr('data-cta');
                $(this).find(".appdownload").html('<a onclick = "trackGTM(\'offerCTA\',\'' + myid + ':' + myindex + ':' + mycta +'\')" href="/scratch-power-app" target="_blank" aria-label="" class="btn white gradient-horizontal">DOWNLOAD APP</a></div>')
            });
            return "Windows Phone";
        }

        if (/android/i.test(userAgent)) {
            $(".offer-coupon").each(function (index) {
                var myid = $(this).attr('data-id');
                var myindex = $(this).attr('data-index');
                var mycta = $(this).find(".appdownload").attr('data-cta');
                $(this).find(".appdownload").html('<a class="google-store" onclick = "trackGTM(\'offerCTA\',\'' + myid + ':' + myindex + ':' + mycta+'\')" href="https://play.google.com/store/apps/details?id=com.firststarcommunications.ampmscratchpower.android" target="_blank"><img class="img-responsive google-store" src="/assets/images/google-badge.png" alt="get it on google play"></a>')
            });
            
            return "Android";
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            $(".offer-coupon").each(function (index) {
                var myid = $(this).attr('data-id');
                var myindex = $(this).attr('data-index');
                var mycta = $(this).find(".appdownload").attr('data-cta');
                $(this).find(".appdownload").html('<a class="ios-store" onclick = "trackGTM(\'offerCTA\',\'' + myid + ':' + myindex + ':' + mycta +'\')" href="https://itunes.apple.com/us/app/id564049196" target="_blank"><img class="img-responsive" src="/assets/images/ios-badge.png" alt="download on the app store"></a>')

            });
           return "iOS";
        }
        $(".offer-coupon").each(function (index) {
            var myid = $(this).attr('data-id');
            var myindex = $(this).attr('data-index');
            var mycta = $(this).find(".appdownload").attr('data-cta');
            $(this).find(".appdownload").html('<a  onclick = "trackGTM(\'offerCTA\',\'' + myid + ':' + myindex + ':' + mycta +'\')" href="/scratch-power-app" target="_blank" aria-label="" class="btn white gradient-horizontal">DOWNLOAD APP</a></div>')

        });
        return "unknown";
    }
   
   
    
});


// $(window).load(function() {
 
//    var $grid = $('.grid').masonry({
//      itemSelector: '.grid-item', // use a separate class for itemSelector, other than .col-
//      columnWidth: '.grid-sizer',
//      percentPosition: true
//      // initLayout: false
//      //stagger: 250,
//    });
//    setTimeout(function() {
//     // $grid.masonry();
//     //  AOS.init(); 
//    },200);
   
   
    
// });